import React from 'react';

import { connect } from 'react-redux';
import Headline from '../../atoms/Headline';
import {
  getPaymentGroupLabel,
  getPaymentOptionsLabelFinishView,
  getPayeverChosen,
  beautifyPrice
} from '../../../utils';
import OrderFormDataDisplay from '../../molecules/OrderFormDataDisplay';
import moment from 'moment';
import 'moment/locale/de';

var AppConfig = require('../../../config.json');

class FinishOverview extends React.Component {
  constructor(props) {
    super(props);
    this.getOptions = this.getOptions.bind(this);
    this.findConfiguration = this.findConfiguration.bind(this);
    this.state = {init: false};
  }
  componentDidMount() {
    this.setState({init:true});
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (!this.state.init && nextState.init);
  }
  getOptions(opt, n) {
    const bundle = this.props.status.project.data.bundles.find(
      this.findConfiguration
    );
    var label = bundle.configuration[opt.configuration].label;
    if(label.toLowerCase()==='versicherung wg') {
      label = "Wertgarantie";
    }
    
    return (
      <div key={`opt_${n}`}>
        <span className="label">
          {label}:&nbsp;
        </span>
        <span className="choice">
          {bundle.configuration[opt.configuration].choices[opt.choices].label}
        </span>
      </div>
    );
  }
  findConfiguration(bundle) {
    return this.props.status.bundle.id === bundle.id;
  }

  paymentSpecs(paymentChoice) {
    const { label, subline } = getPaymentGroupLabel(paymentChoice);
    return (
      <span className="paymentlabel">
        {label} {subline}
      </span>
    );
  }

  paymentOptionsSpecs(paymentChoice) {
    var payeverChoice = '';
    const { label, subline } = getPaymentOptionsLabelFinishView(
      paymentChoice.group,
      paymentChoice.data[0]
    );
    if(this.props.status.payment.type === 'sf' && this.props.payever.isSuccess && this.props.payever.id!==0) {
      payeverChoice = getPayeverChosen(this.props.payever.details);
    }

    return (
      <div>
        <span className="paymenttype">{label}</span>
        <br />
        <span className="paymentprice">{payeverChoice!==''?payeverChoice:subline}</span>
      </div>
    );
  }

  getCustomDataElement(itm, n) {
    var elem;
    if (
      !this.props.status.order.form.customdata.hasOwnProperty(itm.key) ||
      this.props.status.order.form.customdata[itm.key] === '' ||
      itm.type === 'hidden'
    ) {
      return null;
    }
    if (itm.type === 'checkbox') {
      elem = (
        <div className={itm.key}>
          <span>{itm.label}: </span>
          {this.props.status.order.form.customdata[itm.key] ? 'Ja' : 'Nein'}
        </div>
      );
    } else {
      elem = (
        <div className={itm.key}>
          <span>{itm.label}: </span>
          {this.props.status.order.form.customdata[itm.key]}
        </div>
      );
    }
    return (
      <div
        className={`customitem item_${n} type_${itm.type}`}
        key={`customdata_${n}`}
      >
        {elem}
      </div>
    );
  }

  render() {
    const paymentChoice = {
      group: this.props.status.payment.group,
      id: this.props.status.payment.id
    };
    if (this.props.status.payment.group === 'financing') {
      paymentChoice.type = this.props.status.payment.type;
      paymentChoice.data = [
        {
          price: this.props.status.payment.paymentPrice,
          runtime: this.props.status.payment.paymentRuntime
        }
      ];
    } else if (this.props.status.payment.group === 'payever') {
      paymentChoice.type = this.props.status.payment.type;
      paymentChoice.data = [
        {
          price: this.props.status.payment.paymentPrice,
          type: this.props.status.payment.type
        }
      ];
    } else {
      paymentChoice.type = this.props.status.payment.id;
      paymentChoice.data = [
        {
          price: this.props.status.payment.paymentPrice,
          type: this.props.status.payment.type
        }
      ];
    }
    const bundle = this.props.status.project.data.bundles.find(
      this.findConfiguration
    );
    return (
      <div id="orderoverview" className="orderoverview">
        <div className="orderoverviewheader">
          <div className="headline">
            <h2>
              Ihre Bestellung vom {moment().format(AppConfig.dateFormat)} - Nr.{this.props.status.submit.data.id}
            </h2>
          </div>
        </div>

        <div className="orderoverviewbody">
          <div className="section bundle">
            <div className="header">
              <Headline typeOf="h3">{`${AppConfig.finishview.bundle
                .headline}:`}</Headline>
            </div>
            <div className="sectioncontent">
              {this.props.status.project.data.bundles
                .filter(b => b.id === this.props.status.bundle.id)
                .map((bundle, n) => (
                  <div key={`bundle${n}`}>{bundle.deviceName}</div>
                ))}
                
                {!this.props.status.project.isDep &&
                <div className="shipping">
                  <strong>{AppConfig.shipping.label}</strong> <span>{bundle.shippingText}</span>
                </div>
                }
                {this.props.status.project.isDep &&
                <div className="shipping">
                  <strong>{AppConfig.shippingDep.label}</strong> <span>{bundle.depDelivery}</span>
                </div>
                }
            </div>
          </div>

          <div className="section options">
            <div className="header">
              <Headline typeOf="h3">{`${AppConfig.finishview.options
                .headline}:`}</Headline>
            </div>
            <div className="sectioncontent">
              {this.props.status.options.articleConfig.map((opt, n) =>
                this.getOptions(opt, n)
              )}
               { this.props.status.requestSerial.isset && this.props.status.requestSerial.sn!=="" &&
                  <div style={{marginTop:"10px"}}><Headline typeOf="h3">Seriennummer des Gerätes</Headline>
                  <p style={{marginTop:"5px"}}>{this.props.status.requestSerial.sn}</p></div>
                }
            </div>
          </div>

          <div className="section payment">
            <div className="header">
              <Headline typeOf="h3">{`${AppConfig.finishview.payment
                .headline}:`}</Headline>
            </div>
            <div className="sectioncontent">
              {this.paymentSpecs(paymentChoice)}
              {this.paymentOptionsSpecs(paymentChoice)}
            </div>
          </div>

          <div className="section order personal">
            <div className="header">
              <Headline typeOf="h3">{`${AppConfig.finishview.personal
                .headline}:`}</Headline>
            </div>
            <div className="sectioncontent">
              <div className="datawrapper">
                <OrderFormDataDisplay
                  type="personal"
                  data={this.props.status.order.form}
                  teacher={this.props.status.project.teachers}
                />

                {this.props.status.project.teachers ? (
                  <div className="data">
                  <div className="header">
                    <Headline typeOf="h3">{`${AppConfig.checkoutview.teacher
                      .headline}:`}</Headline>
                  </div>
                    <div className="nameschule">Name der Schule: {this.props.status.order.form.schoolname}</div>
                    
                      <div className={`col col_0}`} key={`checkteacher_0`}>
                        <strong>{AppConfig.teacher.upload.label}</strong>: Ja
                      </div>
                  
                  </div>
              ) : null}
              </div>
            </div>
          </div>

          

          {this.props.status.payment.type !== 'rg' &&
          this.props.status.payment.type !== 'sk' &&
          this.props.status.payment.type !== 'sf'? (
            <div className="section order banking">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.finishview.banking
                  .headline}:`}</Headline>
              </div>
              <div className="sectioncontent">
                <div className="datawrapper">
                  <OrderFormDataDisplay
                    type="banking"
                    data={this.props.status.order.form}
                  />
                </div>
              </div>
            </div>
          ) : null}


          {this.props.status.order.form.support.length !== 0 ? (
            <div className="section support">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.finishview.support
                  .headline}:`}</Headline>
              </div>
              <fieldset name={AppConfig.finishview.support.headline}>
                <div className="data">
                  {this.props.status.order.form.support.map((itm, n) => (
                    <div className={`col col_${n}`} key={`check_${n}`}>
                      <strong>{AppConfig.supportTypes[itm].label}</strong>: Ja
                    </div>
                  ))}
                </div>
                {bundle.sponsoring.active && (
                  <div className="sponsoring">
                    <div className="col col_1">
                      <strong>Förderbetrag </strong>: <span dangerouslySetInnerHTML={{__html:beautifyPrice(bundle.sponsoring.supportPrice)}} /> €
                    </div>
                    {bundle.sponsoring.active && this.props.status.payment.type!=='sf' && (
                    <div className="col col_2">
                      <strong>Eigenanteil </strong>: <span dangerouslySetInnerHTML={{__html:beautifyPrice(bundle.sponsoring.customerPrice)}} /> €
                    </div>
                    )}
                  </div>)}
              </fieldset>
            </div>
          ) : null}

          {this.props.status.project.data.customdata.length !== 0 ? (
            <div className="section customdata">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.finishview.customdata
                  .headline}:`}</Headline>
              </div>
              <fieldset name={AppConfig.finishview.customdata.headline}>
                <div className="data">
                  {this.props.status.project.data.customdata.map((itm, n) =>
                    this.getCustomDataElement(itm, n)
                  )}
                </div>
              </fieldset>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    status: state.status,
    payever: state.payever
  };
};

export default connect(mapStateToProps, null)(FinishOverview);



// WEBPACK FOOTER //
// ./src/components/organisms/FinishOverview/FinishOverview.js